import types from '../types/address'
import startTypes from '../types/start'
import orchestratorTypes from '../types/orchestrator'
import {Map, List} from 'immutable'

const initialAddresses = List()

function addresses(state = initialAddresses, action) {
  switch (action.type) {
    case types.FETCH_SUCCESS:
      return List(action.payload.addresses)
    case types.SAVE_SUCCESS:
      return state.push(action.payload.address)
    case orchestratorTypes.START:
      return initialAddresses
    default:
      return state
  }
}

const initialAdd = Map({
  address: '',
  number: '',
  floor: '',
  apartment: '',
  postalCode: '',
  emptyFieldErrors: Map({
    address: '',
    number: '',
    postalCode: ''
  }),
})

function add(state = initialAdd, action) {
  switch (action.type) {
    case types.SET_ADDRESS:
      return state.merge({
        address: action.payload.value,
        emptyFieldErrors: state.get('emptyFieldErrors').set('address', '')
      })
    case types.SET_FLOOR:
      return state.set('floor', action.payload.value)
    case types.SET_APARTMENT:
      return state.set('apartment', action.payload.value)
    case types.SET_POSTAL_CODE:
      return state.merge({
        postalCode: action.payload.value,
        emptyFieldErrors: state.get('emptyFieldErrors').set('postalCode', '')
      })
    case types.SET_STREET_NUMBER:
      return state.merge({
        number: action.payload.value,
        emptyFieldErrors: state.get('emptyFieldErrors').set('number', '')
      })
    case types.SET_EMPTY_FIELD_ERROR:
      return state.set('emptyFieldErrors', Map(action.payload.emptyFieldErrors))
    case types.SAVE_SUCCESS:
    case orchestratorTypes.START:
      return initialAdd
    default:
      return state
  }
}

const initialRoot = Map({
  tab: 0,
  selected: 0,
  isFetching: false,
  isSaving: false,
  isModifying: false,
  error: '',
})

function root(state = initialRoot, action) {
  switch (action.type) {
    case types.SET_TAB:
      return state.set('tab', action.payload.tab)
    case orchestratorTypes.NEXT_STEP_FROM_START:
      return state.set('tab', action.payload.addressTab)
    case startTypes.GET_TRANSACTION_SUCCESS:
      return state.set('selected', action.payload.transaction.ClientAddress.ID)
    case types.FETCH:
      return state.merge({
        isFetching: true,
        error: '',
      })
    case types.FETCH_SUCCESS:
      return state.merge({
        isFetching: false,
        error: '',
      })
    case types.FETCH_FAIL:
      return state.merge({
        isFetching: false,
        error: action.payload.error,
      })
    case types.SET_ADDRESS:
      return state.set('error', '')
    case types.SAVE:
      return state.merge({
        isSaving: true,
        error: '',
      })
    case types.SAVE_SUCCESS:
      return state.merge({
        selected: action.payload.address.ID,
        isSaving: false,
        error: '',
      })
    case types.SAVE_FAIL:
      return state.merge({
        isSaving: false,
        error: action.payload.error,
      })
    case types.SET_SELECTED:
      return state.set('selected', action.payload.selected)
    case types.MODIFY_TRANSACTION:
      return state.merge({
        isModifying: true,
        error: '',
      })
    case types.MODIFY_TRANSACTION_SUCCESS:
      return state.merge({
        isModifying: false,
        error: '',
        tab: 0,
      })
    case types.MODIFY_TRANSACTION_FAIL:
      return state.merge({
        isModifying: false,
        error: action.payload.error,
      })
    case orchestratorTypes.START:
      return initialRoot
    default:
      return state
  }
}

export default function(state, action) {
  const m = Map({
    addresses: addresses(state ? state.get('addresses') : undefined, action),
    add: add(state ? state.get('add') : undefined, action),
  })
  return root(state, action).merge(m)
}



// WEBPACK FOOTER //
// ./src/sections/rentV2/reducers/address.js